const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5006";
let authToken = "";

export function setAuthToken(token = "") {
  authToken = token || "";
}

async function request(path, options = {}) {
  const url = `${BASE_URL}${path}`;
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {})
  };
  if (authToken) {
    headers.Authorization = `Bearer ${authToken}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
    body: options.body ? JSON.stringify(options.body) : undefined,
    credentials: "include",
  });

  const contentType = response.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");

  if (!response.ok) {
    let errorPayload = null;
    try {
      errorPayload = isJson ? await response.json() : await response.text();
    } catch (_) {
      // ignore parse errors; we'll fall back to generic message
    }

    const messageFromBody = typeof errorPayload === "object"
      ? errorPayload?.statusText || errorPayload?.error || errorPayload?.message
      : errorPayload;

    const error = new Error(messageFromBody || `Request failed with status ${response.status}`);
    error.status = response.status;
    if (errorPayload) error.data = errorPayload;
    throw error;
  }

  if (response.status === 204) return null;
  if (isJson) return response.json();
  return response.text();
}

export function apiGet(path, options = {}) {
  return request(path, { method: "GET", ...options });
}

export function apiPost(path, body, options = {}) {
  return request(path, { method: "POST", body, ...options });
}

export function apiPut(path, body) {
  return request(path, { method: "PUT", body });
}

export function apiDelete(path) {
  return request(path, { method: "DELETE" });
}

export { BASE_URL };
